import { Component, OnInit } from '@angular/core';
import *as moment from "moment";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { EnquiryService } from 'src/app/services/Enquiry/enquiry.service';

@Component({
    selector: 'app-appointment',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {

    constructor(private enquiryService: EnquiryService, private lookupService: LookupService, public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }



    SearchModel = {
        EnquiryTypeID: 0,
        EnquiryNo: '',
        FromDate: moment(new Date()).format('DD-MMM-YYYY'),
        ToDate: moment(new Date()).format('DD-MMM-YYYY'),
        PersonTypeID: 0,
    }

    AppointmentModel = {
        StaffID: 0,
        Agenda: '',
        MeetingDate: moment(new Date()).format('DD-MMM-YYYY'),
        MeetingTime: moment(new Date()).format('HH:mm'),
        EnquiryTypeID: 0,
        EnquiryID: 0,
        MeetingLogID: 0,
        EnquiryStatusID: 0,
        Remarks: '',
        IsMeeting: false,
        CloseDate: moment(new Date()).format('DD-MMM-YYYY'),
        CloseTime: moment(new Date()).format('HH:mm'),
    }

    ClearSearch() {
        this.SearchModel.EnquiryTypeID = 0;
        this.SearchModel.EnquiryNo = '';
        this.SearchModel.FromDate = moment(new Date()).format('DD-MMM-YYYY');
        this.SearchModel.ToDate = moment(new Date()).format('DD-MMM-YYYY');
        this.SearchModel.PersonTypeID = 0;
    }
    Submitted = false;
    ClearEnquiry() {
        this.AppointmentModel.MeetingDate = moment(new Date()).format('DD-MMM-YYYY');
        this.AppointmentModel.MeetingTime = moment(new Date()).format('HH:mm');
        this.AppointmentModel.StaffID = 0;
        this.AppointmentModel.Agenda = '';
        this.AppointmentModel.Remarks = '';
        this.Submitted = false;

    }
    ClearMeeting() {
        this.AppointmentModel.IsMeeting = false;

    }
    PersonTypeList: any;
    GetPersonType() {
        this.lookupService.GetLookupsList('EnqPersonType', '').subscribe((data: any) => {
            this.PersonTypeList = data.LookupItems;
        });
    };
    EnquiryTypeList: any;
    GetEnquiryType() {

        this.spinnerService.show();
        var model = {
            ItemId: this.SearchModel.PersonTypeID,
        }
        this.lookupService.GetLookupsList('EnquiryType', JSON.stringify(model)).subscribe((data: any) => {
            this.EnquiryTypeList = data.LookupItems;
            this.spinnerService.hide();
        });
    }
    StaffList: any;
    GetAllStaff() {
        this.lookupService.GetLookupsList('StaffName', '').subscribe((data: any) => {
            this.StaffList = data.LookupItems;
        });
    }
    MeetingList: any;
    GetAllMeeting() {
        this.spinnerService.show();
        
    this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
   
        this.enquiryService.GetAllMeeting(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
            this.MeetingList = data.EnquiryDetails;
            this.spinnerService.hide();

        })

    }
    SelectedRowID = 0
    SetAddNote(obj) {
        this.SelectedRowID = obj.MeetingLogID;
        this.AppointmentModel.EnquiryID = obj.EnquiryID;
        this.AppointmentModel.MeetingLogID = obj.MeetingLogID;
        this.AppointmentModel.EnquiryTypeID = obj.EnquiryTypeID;
        this.AppointmentModel.EnquiryStatusID = obj.EnquiryStatusID;
    }

    Notes = '';
    SetViewNote(obj) {
        this.Notes = '';
        this.SelectedRowID = obj.MeetingLogID;
        this.AppointmentModel.EnquiryID = obj.EnquiryID;
        this.AppointmentModel.MeetingLogID = obj.MeetingLogID;

        this.enquiryService.GetMeetingAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
            if (response.webResponse.Status) {
                this.Notes = response.RemarksList[0].Remarks;
            }

        });
    }
    ValidityState() {
        return this.AppointmentModel.StaffID == 0;
    }

    loadingMeeting = false;

    SaveMeetingAddNote(Addvalid, Meetvalid) {
        this.Submitted = true;
        this.AppointmentModel.CloseTime = this.AppointmentModel.CloseTime!=null && this.AppointmentModel.CloseTime!=''?moment(new Date(this.AppointmentModel.CloseTime)).format('HH:mm'):'';
        this.AppointmentModel.MeetingTime = this.AppointmentModel.MeetingTime!=null && this.AppointmentModel.MeetingTime!=''? moment(new Date(this.AppointmentModel.MeetingTime)).format('HH:mm'):'';
        if (this.AppointmentModel.IsMeeting) {
            if (Meetvalid && !this.ValidityState()) {
                this.Submitted = false;
                this.loadingMeeting = true;

                this.enquiryService.SaveMeetingAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
                    this.loadingMeeting = false;
                    if (response.webResponse.Status) {
                        this.globalHelper.CheckActionStatus(response);
                        this.ClearEnquiry();
                        this.GetAllMeeting();
                    }

                });
            }
        }
        else {

            if (Addvalid) {
                this.Submitted = false;
                this.loadingMeeting = true;
                this.enquiryService.SaveMeetingAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
                    this.loadingMeeting = false;
                    if (response.webResponse.Status) {
                        this.globalHelper.CheckActionStatus(response);
                        this.ClearEnquiry();
                        this.GetAllMeeting();
                    }

                });
            }
        }

    }


    CurrentTime: any;
    CurrentDate: any;
    ngOnInit() {
        this.CurrentTime = moment(new Date()).format('HH:mm');
        this.CurrentDate = moment(new Date()).format('DD-MMM-YYYY');
        this.GetPersonType();
        this.GetEnquiryType();
        this.GetAllStaff();
        this.GetAllMeeting();
    }

}
